import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';

import { Log } from 'app/core/log';
import { AuthService } from 'app/core/auth.service';
import { ConfigService } from 'app/core/config.service';

@Injectable()
export class LoggingService {

  constructor(private http: HttpClient,
    private authService: AuthService,
    private configService: ConfigService) {
  }

  log(message) {
    console.log('Logging from loggingService:', message);

    if (this.authService.isSignedIn()) {
      const log: Log = {
        message: String(message)
      };
      this.configService.getConfigAsync().pipe(
        switchMap(config => 
          this.http.post(config.portalApiEndpoint + 'log', log)
        )
      ).subscribe();
    }
  }
}
